import gql from 'graphql-tag'

export const GET_ALL_CITIES = gql`
query searchCity($city: String){
  cities: Territories(where: {DistrictName: {_ilike: $city}}, distinct_on: DistrictName) {
    id
    name:DistrictName
    StateName
  }
}`

export const GET_CITY_DETAIL = gql`
query searchCity($city: String){
  cities: Territories(where: {DistrictName: {_eq: $city}}, limit:1) {
    id
    city:DistrictName
    state:StateName
    country:CountryName
    
  }
}`
